<template>
  <div class="root">
    <b-container fluid>
      <b-row class="p-1">
        <b-col lg="4"></b-col>
        <b-col lg="4">
          <b-card variant="light" class="mt-5 p-1 logwrap">
            <div v-if="ongoing" class="alert alert-info p-3">
              You Have an unfinished Test, which will resume in
              {{ countdown }}secs
            </div>

            <b-overlay
              :show="confirmingemail"
              rounded
              opacity="0.6"
              spinner-small
              spinner-variant="primary"
            >
              <p v-if="confirmingemail" class="text-center py-3">
                Confirming your email...
              </p>
            </b-overlay>
            
            <div
              v-if="error"
              class="alert alert-danger alert-dismissible p-3"
              v-html="errmsg"
            ></div>

            <div
              v-if="reason == 'outdated'"
            >
              <p v-html="errmsg"></p>
              <p class="clickhere" @click="updateApp()">
                Click here to update your app
              </p> 
            </div>

            <div v-if="confirmed" class="m-2 p-2" v-html="cmsg"></div>
            <p v-if="errorReason == 'unconfirmed'">
              You did not receive any mail?
              <span @click="resendMail" class="email-resend">Resend mail</span>
              <b-overlay
                :show="resending"
                rounded
                opacity="0.6"
                spinner-small
                spinner-variant="primary"
              >
              </b-overlay>
            </p>
            <div
              v-if="$route.query.cid && confirmed == false && !confirmingemail"
            >
              If your email is not confirmed automatically.
              <p class="clickhere" @click="confirmEmail()">
                Click here to confirm
              </p>
            </div>
            <p
              v-if="resent"
              :class="{
                'resent-false': !resendStatus,
                'resent-true': resendStatus
              }"
            >
              {{ resendMessage }}
            </p>

            <div
              v-if="this?.$route?.query?.redirect?.includes('/testspace/')"
              class="alert alert-info alert-dismissible p-3"
            >
              You have to first Login to be able to access the testspace. After Logging in, you will be redirected to the testspace.
            </div>


            <form @submit.prevent="logUser">
              <p class="hlogin">Login</p>

              <span class="label">Email</span>
              <div class="form-input">
                <b-input-group class="form-input" label-for="email">
                  <b-form-input
                    v-model="login.email"
                    type="email"
                    id="email"
                    class="loginp p-3"
                    placeholder="user@example.com"
                    required
                    autocomplete="email"
                  >
                  </b-form-input>
                </b-input-group>
              </div>

              <b-form-group class="mt-1" label-for="password">
                <span class="label">Password</span>

                <b-input-group class="input-pw" v-if="showStar == true">
                  <div class="">
                    <b-form-input
                      v-model="login.password"
                      type="password"
                      id="password"
                      class="form-pw p-3 mt-1"
                      placeholder="*********"
                      autocomplete="password"
                      required
                      @focus="setErr"
                    >
                    </b-form-input>
                  </div>

                  <div>
                    <b-icon-eye-fill
                      font-scale="1.5"
                      class="close-button"
                      @click="
                        showText = true;
                        showStar = false;
                      "
                      variant="secondary"
                    ></b-icon-eye-fill>
                  </div>
                  
                </b-input-group>

                <b-input-group class="input-pw" v-if="showText == true">
                  <div>
                    <b-form-input
                      v-model="login.password"
                      type="text"
                      id="password"
                      class="form-pw p-3 mt-1"
                      placeholder=""
                      required
                      @focus="setErr"
                    >
                    </b-form-input>
                  </div>
                  
                  <b-icon-eye-slash
                    font-scale="1.5"
                    class="close-button"
                    @click="
                      showText = false;
                      showStar = true;
                    "
                    variant="secondary"
                  ></b-icon-eye-slash>
                </b-input-group>
              </b-form-group>

              <b-row>
                <b-col md="3"></b-col>
                <b-col md="6">
                  <b-overlay
                    :show="logginin"
                    rounded
                    opacity="0.6"
                    spinner-small
                    spinner-variant="primary"
                    class=""
                  >
                    <b-button
                      :disabled="logginin"
                      type="submit"
                      class="btn-md p-1 w-100"
                      variant="success"
                      >Login</b-button
                    >
                  </b-overlay>

                  <b-button
                    v-if="logginin"
                    class="w-100 p-2 mt-3 btntxt"
                    variant="dark"
                    @click="stopproceed"
                  >
                    Cancel
                  </b-button>

                  <div class="be-links p-2">
                    Don't have an account?
                    <b-link class="be-link" :to="{ name: 'signup' }">
                      Sign up</b-link
                    ><br /><br />
                    <b-link class="be-link" :to="{ name: 'forgot' }"
                      >Forgot password</b-link
                    >
                  </div>
                </b-col>
                <b-col md="3"></b-col>
              </b-row>
            </form>
          </b-card>
        </b-col>
        <b-col lg="4"></b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import store from "@/store";
import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";
//import NProgress from "nprogress";

export default {
  data() {
    return {
      login: this.createLogin(),
      countdown: 5,
      logginin: false,
      frompath: "",
      cmsg: "",
      confirmed: false,
      showStar: true,
      showText: false,
      errorReason: "",
      resendStatus: false,
      resendMessage: "",
      resent: false,
      resending: false,
      confirmingemail: false,
      reason: ""
    };
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch("loginmaster/setOrigin");
    store.dispatch("loginmaster/setEntryType", "platform");

    let loggedout = store.state.loggedout;

    if (loggedout == false) {
      next(vm => {
        if (vm.loggedin) {
          vm.$router.push({
            name: "landing"
          });
        }
      });
    }

    next();
    //NProgress.done();
  },
  async mounted() {

    this.$store.state.isNativePlatform = Capacitor.isNativePlatform();

    const appInfo = Capacitor.isNativePlatform() ? await App.getInfo() : {};
    this.$store.state.appVersion = Capacitor.isNativePlatform()
      ? appInfo.version
      : process.env.VUE_APP_CURRENT_VERSION;

    this.logOut();
    if (this.$route.query.cid) {
      this.confirmingemail = true;
      this.confirmemail(this.$route.query.cid).then(response => {
        this.confirmingemail = false;
        this.confirmed = response.confirmed;
        this.cmsg = response.msg;
      });
    }

    // Load the Google Sign-In client library
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.setAttribute('crossorigin','*');
    document.head.appendChild(script);

    // Wait for the library to load
    script.onload = () => {
      window.google.accounts.id.initialize({
        client_id: '83163541009-c3k7b5gtt9igr2poniaogpmibangtob4.apps.googleusercontent.com',
        callback: this.handleCredentialResponse,
        // If you want to use redirect mode instead of popup:
        login_uri: 'https://app.usequicktest.com/login',
        auto_select: true // This will automatically select the user if they are already signed in
      });
      window.google.accounts.id.renderButton(
        document.getElementById('buttonDiv'),
        { theme: 'outline', size: 'large' } // customization attributes
      );
      // Optional: display the One Tap dialog for a smoother UX
      // window.google.accounts.id.prompt(); 
    };
  },
  created() {
    //this.$router.push(this.frompath)
  },

  updated() {
    if (this.loggedin && this.$route.query.redirect) {
      this.$router.push(this.$route.query.redirect);
    } else if (this.ongoing) {
      if (this.start_config.start == "No") {
        this.movedown();
      } else {
        setTimeout(() => {
          this.countdown = this.countdown - 1;
          if (this.countdown == 0) {
            this.movedown();
          }
        }, 1000);
      }
    }
  },
  computed: {
    ...mapState({
      details: state => state.loginmaster.details,
      loggedin: state => state.loginmaster.loggedIn,
      ongoing: state => state.ongoing,
      start_config: state => state.exam.start_config,
      error: state => state.loginmaster.error,
      errmsg: state => state.loginmaster.errmsg,
      loggedout: state => state.loggedout,
      origin: state => state.loginmaster.api_origin
    })
  },
  methods: {
    async logUser() {
      const isNativePlatform = Capacitor.isNativePlatform();

      const appInfo = isNativePlatform ? await App.getInfo() : {};
      const appVersion = appInfo.version;

      this.login.channel = isNativePlatform ? "app" : "web";
      this.login.version = isNativePlatform
        ? appVersion
        : process.env.VUE_APP_CURRENT_VERSION;

      this.setloader();

      //NProgress.start();
      return await this.$store
        .dispatch("loginmaster/sendLogin", this.login)
        .then(response => {

          this.errorReason = response?.message;
          this.reason = response?.reason;


          if (this.error) {
            this.logginin = false;
          }

          store.watch(
            (state) => {
              return state;
            },
            async (newState) => {
              const newObj = { ...newState };
              delete newObj.admin;
              delete newObj.dashboard;

              // console.log(newObj, "Pre Saving");
              await Preferences.set({
                key: "store",
                value: JSON.stringify(newObj),
              });
            },
            { immediate: true }
          );

          store.subscribe(async (mutation, state) => {
            const newObj = { ...state };
            delete newObj.admin;
            delete newObj.dashboard;

            // console.log(newObj, "Pre Saving");
            await Preferences.set({
              key: "store",
              value: JSON.stringify(newObj),
            });
          });
          
          if (this.loggedin && this.$route.query.redirect) {
            this.$router.push(this.$route.query.redirect);
          } else if (this.loggedin && !this.ongoing) {
            if (this.details.category == "Organization") {
              this.$router.push({
                name: "orgdashboardhome"
              });
            }else{
              this.$router.push({
                name: "dashhome",
                params: {
                  fullname: this.details.fullname
                }
              });
            }
            
          }
        })
        .catch((err) => {
          this.$bvModal
            .msgBoxOk(
              `Could not Log in. Confirm your network is on and going through and your Login details are correct. Try Logging in again or with a better Network Connectivity. If issue persists, contact support. ${err} `,
              {
                title: "Login Error",
                size: "xs",
                centered: true
              }
            )
            .then(() => {
              this.logginin = false;
            });
        });
    },
    handleCredentialResponse(response) {
      console.log("Encoded JWT ID token: " + response.credential);
      // Send the response.credential to your backend for verification
    },
    onSignIn(googleUser) {
      var profile = googleUser.getBasicProfile();
      console.log(profile)
      console.log('ID: ' + profile.getId()); // Do not send to your backend! Use an ID token instead.
      console.log('Name: ' + profile.getName());
      console.log('Image URL: ' + profile.getImageUrl());
      console.log('Email: ' + profile.getEmail()); // This is null if the 'email' scope is not present.
    },
    async confirmEmail() {
      this.confirmingemail = true;
      this.confirmemail(this.$route.query.cid).then(response => {
        // console.log(response)
        this.confirmingemail = false;
        this.confirmed = response.confirmed;
        this.cmsg = response.msg;
      });
    },
    movedown() {
      if (this.start_config.start == "No") {
        this.$router.push({
          name: "dashhome"
        });
      } else {
        let categoryName = JSON.parse(this.start_config.category).name;
        this.$router.push({
          name: "testhall",
          params: {
            trackid: this.start_config.track_id,
            category: categoryName,
            institution: this.start_config.institution_shortname
          }
        });
      }
    },
    updateApp() {
      window.location =
        "https://play.google.com/store/apps/details?id=com.quicktestng.app";
    },
    async createLogin() {
      return {
        email: "",
        password: "",
        page: "login",
        channel: "",
        version: ""
      };
    },
    resendMail() {
      this.resent = false;
      this.resending = true;
      let payload = {
        email: this.login.email,
        origin: this.origin
      };
      try {
        if (this.login.email.length == 0) {
          this.resendMessage =
            "Please type in your email in the email field below";
          this.resendStatus = false;

          return;
        } else {
          return this.resendVerifyMail(payload).then(response => {
            this.resent = true;
            this.resending = false;
            this.resendStatus = response.status;
            this.resendMessage = response.message;
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    setloader() {
      this.logginin = true;
    },
    stopproceed() {
      this.logginin = false;
    },
    ...mapActions("loginmaster", [
      "setErr",
      "confirmemail",
      "resendVerifyMail"
    ]),
    ...mapActions(["logOut"])
  }
};
</script>

<style scoped>
.clickhere {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}
.be-links {
  text-align: center;
  font-size: 0.75rem;
}

.inpdiv {
  padding: 10px;
}

.sign-up {
  text-align: center;
  margin-top: 2rem;
}

.be-link {
  color: #00984a;
}
.close-button {
  position: relative;
  cursor: pointer;
  top: -30px;
  left: 90%;
  z-index: 9999;
}

.input-pw{
  display: flex;
  flex-direction: column;
}

.form-pw{
  width: 100%;
}

.btn-md {
  font-size: 1rem;
  color: white;
  background-color: #00984a;
  cursor: pointer;
}
.gsign {
  font-size: 0.8rem;
}
.label {
  font-size: 0.9rem;
}
p {
  line-height: 15px;
}
.logwrap {
  width: 90%;
  margin: 0px auto;
}
.hlogin {
  font-weight: bolder;
  font-size: 1.3rem;
}
.appendage {
  background-color: #afb0ae;
}
.loginp {
  width: 75%;
}
.form-input {
  width: 100%;
}
.email-resend {
  color: #00377b;
  cursor: pointer;
  text-decoration: underline;
}
.resent-false {
  color: rgb(229, 16, 16);
  background-color: rgba(255, 0, 0, 0.496);
  padding: 15px;
  border-radius: 5px 5px;
}
.resent-true {
  color: rgb(28, 121, 28);
  background-color: rgba(37, 195, 19, 0.167);
  padding: 15px;
  border-radius: 5px 5px;
}

@media screen and (max-width: 999px) {
  .close-button {
    border-radius: 14px 14px;
  }
}

@media screen and (min-width: 999px) {
  .close-button {
    left: 90%;
  }
}
</style>
